import pickBy from 'lodash/pickBy';
import { jobSearchPath } from '../../utilities/api_relative_paths';
import { createQueryString } from '../../utilities/utilities';
import { EXCLUSIVE_JOB_TYPE_ID } from '../../utilities/constants/job_related.constants';
import {
  ParamsParserForApi,
  QueryParams,
  GetJobsResponse,
} from '../types';

const parseQueryParamsForApi = (params: ParamsParserForApi): QueryParams => {
  const {
    keyword = '',
    publicationInterval = '',
    type = '',
    isRemote = 'false',
    hasSalaryData = 'false',
    locations,
    places,
    jobLevels,
    newsTopics,
    positionTypes,
    orgNames,
    stages,
  } = params;

  return pickBy({
    keywords: keyword ? [keyword] : null,
    published_at_interval: publicationInterval ? [publicationInterval] : null,
    job_types: type ? [type] : null,
    is_remote: JSON.parse(isRemote) ? isRemote : null,
    has_salary_data: JSON.parse(hasSalaryData) ? hasSalaryData : null,
    locations,
    places,
    career_levels: jobLevels,
    news_topics: newsTopics,
    contract_lengths: positionTypes,
    organization_names: orgNames,
    stage: stages,
  });
};

const createSessionStorageObject = (
  response: GetJobsResponse,
  queryParams: { filter: QueryParams },
  path: string,
): string => {

  const {
    total,
    data,
    page: { size, number },
  } = response;

  return JSON.stringify({
    queryParams: jobSearchPath + createQueryString(queryParams),
    urlReferer: encodeURIComponent(path),
    page: number,
    totalPages: Math.ceil(total / size),
    jobList: data.map((job) => {
      return {
        name: job.name,
        hiddenName: `${job.career_level?.name} position in ${job.news_topics?.[0]?.name}`,
        isExclusive: job.job_type === EXCLUSIVE_JOB_TYPE_ID,
        slug_and_id: job.slug_and_id,
        employer_company_name: job.employer_company?.name,
        employer_company_logo: job.employer_company?.logo,
        places: job?.places.map((place) => place?.name)
      };
    }),
    totalJobs: total,
  });
};

export { parseQueryParamsForApi, createSessionStorageObject };
